import React, { useEffect } from "react";
import Stats from "./Stats";
import { Grid } from "@material-ui/core";

import { red } from "@material-ui/core/colors";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { getPeriodicSales } from "../../redux/actions/salesActions";

// helpers
import { formatCurrency } from "../../utils/helpers";

const SalesThisMonth = ({ period }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    getPeriodicSales(dispatch, period);
  }, [dispatch, period]);

  const {
    salesThisMonthSummary: { loading, sales },
  } = useSelector((state) => state.sales);

  return (
    <Grid item xs={12} sm={12} md={6} lg={3} xl>
      <Stats
        title="Sales This Month"
        loading={loading}
        data={`${formatCurrency("KES", sales)}`}
        amount="KES 300,000"
        chip="Monthly"
        percentageText="-9%"
        percentagecolor={red[500]}
      />
    </Grid>
  );
};

export default SalesThisMonth;
